import { Model } from 'backbone';
import _ from 'lodash';

const
	tips_avatars_path = process.env.SQUAD_LOGOS_PATH,
	team_avatars_path = process.env.AVATARS_PATH;

export class Tip extends Model {
	defaults() {
		return {
			...super.defaults,
			is_postponed: 0
		}
	}
	setAvatar() {
		let avatar_version = this.get('avatar_version'),
			avatar = team_avatars_path + this.get('user_id') + '.png?v=' + avatar_version;

		this.setTipsAvatars()
			.set('avatar', avatar);

		return this;
	}

	setTipsAvatars() {
		let { tips } = this.attributes;

		_.each(tips, ( tip, key ) => {
			tips[key].avatar = tips_avatars_path + tip.predict_winner_squad_id + '.png';
		});

		this.set({ tips });

		return this;
	}
}

export default Tip;